import { forwardRef, Ref } from "react"
import { MenuItem, MenuItemProps } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    destructive: {
        color: theme.palette.tailwind.red[600],
    },
}))

export const DestructiveMenuItem = forwardRef((props: MenuItemProps, ref: Ref<HTMLLIElement>) => {
    const { className, ...rest } = props
    const { classes, cx } = useStyles()

    return <MenuItem ref={ref} className={cx(classes.destructive, className)} {...rest} />
})
